import { useMemo } from 'react';
import { getPermissions, getAccessLevel } from 'src/services/CacheStorage';
import { useCurrentRole } from 'src/hooks/use-auth';
import TypeChecker from 'src/utils/type-checker';

export const useOptions = (type) => {
  // Memoize the result of groups
  const result = useMemo(() => {
    const data = getAccessLevel();
    // Get options
    const options = TypeChecker.isObject(data) ? data.options : null;
    if(TypeChecker.isObject(options)){
      const level = options[type];
      if (TypeChecker.isArray(level)) {
        const length = level.length;
        if(length > 1){
          const single = level.join(',');
          return {isOptions: true, multi: level, single};
        } 
        if(length > 0) return {isOptions: false, single: level[0]};
      } 
    }
    return {isOptions: false};
  }, [type]);

  return result;
};

export const useMenus = (type) => {
  const data = getPermissions();
  const menus = TypeChecker.isObject(data) ? data.menus : null;
  if(TypeChecker.isObject(menus)){
    const obj = menus[type];
    return TypeChecker.isObject(obj) ? obj : {};
  }
  return {};
};

export const usePermissions = (type) => {
  const currentRole = useCurrentRole();

  // Memoize the result of ...
  const result = useMemo(() => {
    const data = getPermissions();
    const roles = TypeChecker.isObject(data) ? data[currentRole] : null;
    if(TypeChecker.isObject(roles)){
      const obj = roles[type];
      return TypeChecker.isObject(obj) ? obj : {};
    }
    return {};
  }, [type]);

  return result;
};